import { render } from "./CustomerResourceTable.vue?vue&type=template&id=a3a79302"
import script from "./CustomerResourceTable.vue?vue&type=script&lang=js"
export * from "./CustomerResourceTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomerResourceTable.vue"]])

export default __exports__